import RestrictionsDecorate from '../../../../facade/restrictions/decorate';

module.exports = RestrictionsDecorate({
  haveOptions: function (selection) {
    const restrictionsFacade = require('../../../../facade/restrictions/restrictions');
    const getRestrictions = _.partial(
      restrictionsFacade.getElementRestrictions,
      selection.id
    );
    const basicRestrictions = getRestrictions('basic');
    if (!basicRestrictions[0] || !basicRestrictions[0]?.text_change_content) {
      basicRestrictions[0] = restrictionsFacade.getAllDefaultPermissions();
    }

    const canReplace = basicRestrictions[0].text_change_content;

    return (canReplace && getRestrictions('source').length) ||
      getRestrictions('dictionary').length ||
      getRestrictions('colors').length ||
      getRestrictions('colors-library').length;
  }
}, { haveOptions: function () { return false; } });
